export const NavItemEnum = {
  ADD_ONS: 'add-ons',
  BUNDLE: 'bundle',
  COMMERCE: 'commerce',
  REVENUE: 'revenue',
  CONTENT: 'content',
  FREE: 'crm',
  MARKETING: 'marketing',
  MARKETING_PLUS: 'marketing-plus',
  DATA: 'data',
  SALES: 'sales',
  SERVICE: 'service',
  SMART_CRM: 'smart-crm',
  SUITE: 'suite'
};
export const NavSectionEnum = {
  BUNDLE: 'bundle',
  CORE: 'core',
  ENHANCEMENTS: 'enhancements'
};
export const SegmentedNavItems = {
  [NavSectionEnum.BUNDLE]: [NavItemEnum.SUITE, NavItemEnum.FREE, NavItemEnum.BUNDLE, NavItemEnum.MARKETING_PLUS],
  [NavSectionEnum.CORE]: [NavItemEnum.SMART_CRM, NavItemEnum.MARKETING, NavItemEnum.SALES, NavItemEnum.SERVICE, NavItemEnum.CONTENT, NavItemEnum.DATA, NavItemEnum.COMMERCE, NavItemEnum.REVENUE],
  [NavSectionEnum.ENHANCEMENTS]: [NavItemEnum.ADD_ONS]
};